import { findIndex, isEmpty, isUndefined } from "lodash";
import { ISectionSchema } from "../Section";
import { IControlSchema, RuleOptions } from "../Controls";
import { ICalendarSchema } from "../../libs/controls/Calendar/Calendar";
import { isGroupCheck, validateTelephone } from "./validate";
import { IGroupSchema } from "../../libs/controls/Group";
import { IPanelSchema } from "../../libs/controls/Panel";
import { isNullOrEmpty } from "../../libs/helpers/Utils";
import RulesManager from "./RulesManager";
import {log} from "mathjs";

export interface SectionPercent {
	countRequired: number;
	countNotEmpty: number;
}

function getValue(controlId: string, values: Array<{ controlId: string; value: any }>): any {
	const index = findIndex(values, (x: any) => x.controlid === controlId);
	const value = index > -1 ? values[index].value : null;

	return value;
}

export function recalPercentToSection(
	controls: Array<IControlSchema>,
	values: Array<any>,
	persent: SectionPercent,
	permissiblePanelIDs: Array<string>
) {
	// eslint-disable-next-line no-restricted-syntax
	for (const ctrl of controls) {
		const valueIdx = findIndex(values, (val: any) => val.controlid === ctrl.id && val.value);

		if (!Object.prototype.hasOwnProperty.call(ctrl, "controls")) {
			// Задается сколько надо заполнить процентов
			if (ctrl.required) {
				if (
					ctrl?.value?.length > 0 &&
					ctrl?.extra?.multiple &&
					(ctrl.type.toUpperCase() === "CALENDAR" || ctrl.type.toUpperCase() === "RANGEDMULTICALENDAR")
				) {
					// eslint-disable-next-line guard-for-in,no-restricted-syntax,@typescript-eslint/no-unused-vars
					for (const index in ctrl.value) {
						persent.countRequired++;
					}
				} else if (ctrl.type.toUpperCase() === "GRID" && ctrl?.minLength) {
					persent.countRequired++;
					for (let i = 0; i < ctrl.minLength; i++) {
						persent.countRequired++;
					}
				} else {
					persent.countRequired++;
				}
			}

			// Добавляет в зависимости от заполненности процент заполненности
			if (valueIdx > -1 && ctrl.required) {
				const { value } = values[valueIdx];
				if (
					(ctrl.type.toUpperCase() === "CALENDAR" || ctrl.type.toUpperCase() === "RANGEDMULTICALENDAR") &&
					(ctrl as ICalendarSchema).finishDate !== null
				) {
					if (
						typeof value === "object" &&
						!value?.length &&
						!isEmpty(value?.beginDate) &&
						!isEmpty(value?.finishDate)
					) {
						persent.countNotEmpty++;
					} else if (typeof value === "object" && value?.length) {
						// eslint-disable-next-line no-restricted-syntax
						for (const index in value) {
							if (!isEmpty(value[index].beginDate) && !isEmpty(value[index].finishDate)) {
								persent.countNotEmpty++;
							}
						}
					}
				} else if (ctrl.type.toUpperCase() === "CHECKBOXSET") {
					if (value.length > 0) {
						persent.countNotEmpty++;
					}
				} else if (ctrl.type.toUpperCase() === "GRID") {
					let gridEmpty = false;
					// eslint-disable-next-line no-restricted-syntax
					for (const column of ctrl.columns) {
						if (column.required) {
							// TODO: gridEmpty use - need test
							//  value.some((val) => !val?.[column.field] || isNullOrEmpty(val[column.field])
							// eslint-disable-next-line no-loop-func
							value.forEach((val) => {
								// Исключаем из выборки тип i18n complex, поскольку это сервисный компонент, который не требует отображения
								if (column.type?.toUpperCase() === "I18N_COMPLEX") {
									return 
								}
								
								if ((typeof val[column.field] === "undefined" || isNullOrEmpty(val[column.field]))) {
									if (column.rule) {
										column.rule?.forEach((ruleItem) => {
											if (ruleItem.option === "Equal" && val[ruleItem.controlTargetId] !== ruleItem.value) {
												gridEmpty = false;
											} else {
												gridEmpty = true;
											}
										})
									} else {
										gridEmpty = true;
									}
								}
							});
						}
					}

					if (!gridEmpty) persent.countNotEmpty++;
					if (ctrl?.minLength) {
						for (let i = 0; i < ctrl?.minLength; i++) {
							if (value?.[i]) {
								persent.countNotEmpty++;
							}
						}
					}
				} else if (ctrl.type.toUpperCase() === "SELECTBLOCK") {
					if (value && value.length > 0) persent.countNotEmpty++;
				} else {
					persent.countNotEmpty++;
				}
			}
		} else if (isGroupCheck(ctrl as IGroupSchema | IPanelSchema, values[valueIdx])) {
			// dynamic
			if (ctrl.type.toUpperCase() === "PANEL" && valueIdx > -1 && !isEmpty(values[valueIdx].value.rows)) {
				const { rows } = values[valueIdx].value;
				// eslint-disable-next-line no-restricted-syntax
				for (const row of rows) {
					// eslint-disable-next-line no-restricted-syntax
					for (const controlRow of row.controls) {
						const index = findIndex(values, (val: any) => val.controlid === controlRow.id);
						const idxCtrl = findIndex(ctrl.controls, (obj: any) => obj.id === controlRow.name);
						const childControl = ctrl.controls[idxCtrl];

						if (childControl.required) {
							persent.countRequired++;
						}

						if (index > -1 && childControl.required) {
							persent.countNotEmpty++;
						}
					}
				}
			}

			recalPercentToSection(ctrl.controls, values, persent, permissiblePanelIDs);
		} else if (ctrl.type.toUpperCase() === "DYNAMICGRIDPANEL" && valueIdx > -1) {
			// eslint-disable-next-line no-restricted-syntax
			for (const element of values[valueIdx].value) {
				persent.countRequired += element.items.length;
				// eslint-disable-next-line no-restricted-syntax
				for (const item of element.items) {
					const exist = values.some((t) => t.controlid === item.name);
					if (exist) {
						persent.countNotEmpty++;
					}
				}
			}
		}
		if (ctrl.type.toUpperCase() === "GROUP" && ctrl.required) {
			const valuesActual = values[valueIdx]?.value;
			const rulesManager = new RulesManager();

			if (!valuesActual) {
				persent.countNotEmpty++;
				persent.countRequired++;
			}
			// eslint-disable-next-line no-restricted-syntax,guard-for-in
			for (const groupID in valuesActual) {
				const mapping = Object.entries<any>(valuesActual?.[groupID]).map(([controlid, value]) => ({
					controlid,
					value: !isEmpty(value) ? value : null,
				}));
				const mappingForRules = mapping.map(item => ({controlId: item.controlid, value: item.value}));
				const newGroupCtrl = rulesManager.round(ctrl.columns, mappingForRules);
				recalPercentToSection(newGroupCtrl, mapping, persent, undefined);
			}
		}
		if (ctrl.type.toUpperCase() === "TELEPHONE") {
			persent.countRequired++;
			if (!validateTelephone(values[valueIdx]?.value)) {
				persent.countNotEmpty++;
			}
		}
	}
}

export function getPercent(section: ISectionSchema, values: any, checkedPanel: any): number {
	if (!isUndefined(values) && values.length > 0) {
		const percent = {
			countRequired: 0,
			countNotEmpty: 0,
		};

		//Только видимые поля
		const rulesManager = new RulesManager();
		const visibleControls = rulesManager.round(section.controls, values);

		recalPercentToSection(visibleControls, values, percent, checkedPanel);

		return percent.countRequired > 0
			? parseInt(((percent.countNotEmpty / percent.countRequired) * 100).toString(), 10)
			: null;
	}

	return 0;
}

export function calcPercentSidebar(sections: Array<ISectionSchema>, values: any, checkedPanel: any) {
	return sections.map((sect: ISectionSchema): any => ({
		id: sect.id,
		title: sect.title,
		percent: getPercent(sect, values, checkedPanel),
		parent: sect.parent,
		children: sect.children
	}));
}
